var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AnalysisChart',{attrs:{"endpoint":"web/get-body-weight-analysis","data-key":"total_weight","standard-key":"standard_weight","series-label":"Body Weight","standard-label":"Standard Body Weight","yaxis-title":"Weight (g)"}})}
var staticRenderFns = []

export { render, staticRenderFns }